export const HEXAGON_SIZE = 210;
export const QR_CODE_SIZE = 125;
